import { render } from "./form3.vue?vue&type=template&id=0049db46&scoped=true"
import script from "./form3.vue?vue&type=script&lang=js"
export * from "./form3.vue?vue&type=script&lang=js"

import "./form3.vue?vue&type=style&index=0&id=0049db46&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0049db46"]])

export default __exports__